import { clipboardPasteActionLabel, clipboardStatusLabel, type FileBrowserClipboardState } from './fileBrowserClipboard';
import './FileBrowserClipboardBanner.css';

export type FileBrowserClipboardBannerProps = {
  state: FileBrowserClipboardState;
  canPaste: boolean;
  destinationLabel: string;
  busy?: boolean;
  onPaste: () => void;
  onClear: () => void;
};

export function FileBrowserClipboardBanner({
  state,
  canPaste,
  destinationLabel,
  busy = false,
  onPaste,
  onClear
}: FileBrowserClipboardBannerProps) {
  const action = clipboardPasteActionLabel(state);
  const hint = canPaste
    ? `${action} into ${destinationLabel}`
    : 'Open a writable folder to paste.';

  return (
    <div className="file-browser-clipboard-banner" role="status">
      <p className="file-browser-clipboard-banner__text">
        <strong>{clipboardStatusLabel(state)}</strong>
        <span> · {hint}</span>
      </p>
      <div className="file-browser-clipboard-banner__actions">
        <button type="button" disabled={busy || !canPaste} onClick={onPaste}>
          Paste here
        </button>
        <button type="button" disabled={busy} onClick={onClear}>
          Clear
        </button>
      </div>
    </div>
  );
}
